import React from 'react'
import styled from 'styled-components'

import { useGetSubjectBotLinkQuery } from '@/lib/apollo'
import type { ReferenceTier } from '@/lib/apollo/query/get-applicant'

interface Props {
  subjectId: string
  applicationId: string
  customerId: string
  applicantTier?: ReferenceTier | null
  isReferee?: boolean
}

const Container = styled.div`
  position: relative;
  padding: 10px 0;
`

const LinkContainer = styled.div`
  margin-top: 10px;
  overflow-wrap: break-word;
`

const StyledLink = styled.a`
  color: #41a7f5;
  cursor: pointer;
`

const LoadBotLink = ({
  subjectId,
  applicationId,
  customerId,
  applicantTier = null,
  isReferee = false,
}: Props) => {
  const { loading, error, data } = useGetSubjectBotLinkQuery({
    variables: {
      customerId,
      applicationId,
      subjectId,
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  if (loading) {
    return <Container>Loading link...</Container>
  }

  if (
    error ||
    data?.getSubjectBotLink === undefined ||
    data?.getSubjectBotLink === null
  ) {
    return <Container>An error occurred while loading the link.</Container>
  }

  if (applicantTier === null && !isReferee) {
    return (
      <Container>
        Applicant not in the correct state. Please check the applicant is at the
        referencing stage and has signed up on the Goodlord platform.
      </Container>
    )
  }

  return (
    <Container>
      Click the link below to view the chat bot for this applicant. You may also send this
      link to the applicant if they cannot already access it.
      <LinkContainer>
        <StyledLink href={data.getSubjectBotLink} target="_blank" rel="noreferrer">
          {data.getSubjectBotLink}
        </StyledLink>
      </LinkContainer>
    </Container>
  )
}

export default LoadBotLink
